import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
const { Text } = Typography;

const SocialMediaPromotion = () => {

  return (
    <div style={{ background: '#f5f5f5' }}>
      <Card style={{ borderRadius: '10px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
          A great way to market your new ReferUs program
        </div>
        <Text style={{ display: 'block' }}>
          and build an army of referrers via social media, so we have made this easy for you to do just follow the following 3 steps:
        </Text>

        <hr />

        <Row gutter={[16, 0]}>
          <Col span={24}>
            <div className='pb-5'>
                <strong>Step 1:</strong>
                <Text style={{ marginLeft: '10px'}}>Select the social media platform you wish to promote.</Text>
            </div>
          </Col>

          <Col span={24}>
            <div className='pb-5'>
                <strong>Step 2:</strong> 
                <Text style={{ marginLeft: '10px'}}>Copy your promotional page link.</Text>
            </div>
          </Col>

          <Col span={24}>
            <div>
                <strong>Step 3:</strong>
                <Text style={{ marginLeft: '10px'}}>Paste your promotional code in registration to become referrer.</Text>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default SocialMediaPromotion;
